import {createContext, useState} from 'react';

const UserContext = createContext();

export const UserContextProvider = ({children}) => {

    const defaultUserInfo = {
        user: '',
        user_name: '',
        email: '',
        is_active: false,
        is_super_user: false,
        full_name: '',
        id: '',
        // firstName: '',
        // lastName: '',
        isLoggedIn: false,
        jwt: '',
        token_type: '',
        activeTab: 'user',
        last_name: '',
        first_name: '',
    }

    const [userInfo, setUserInfo] = useState(defaultUserInfo)

    const updateUserInfo = (uInfo) => {
        const newUInfo = {...userInfo, ...uInfo};
        sessionStorage.setItem("user", JSON.stringify(newUInfo));
        setUserInfo(newUInfo);
    }



    // logout and clean up
    const Logout = () => {
        setUserInfo(defaultUserInfo)
        sessionStorage.removeItem("user");
    }


    // const setActiveTab = (tab) => {
    //     updateUserInfo({...userInfo, activeTab: tab})
        
    // }

    return <UserContext.Provider 
        value={{
            user:userInfo.user,
            user_name:userInfo.user_name,
            full_name:userInfo.full_name,
            email: userInfo.email,
            is_active: userInfo.is_active,
            is_super_user: userInfo.is_super_user,
            id: userInfo.id,
            last_name: userInfo.last_name,
            first_name: userInfo.first_name,
            isLoggedIn:userInfo.isLoggedIn,
            jwt: userInfo.jwt,
            token_type: userInfo.token_type,
            setIsLoggedIn: (prev, newLoggedIn) => setUserInfo({...userInfo, isLoggedIn: newLoggedIn}),
            setUser: (newUser) => updateUserInfo({...userInfo, user: newUser}),
            setUserName: (newName) => setUserInfo({...userInfo, user_name: newName}),
            setEmail: (newEmail) => setUserInfo({...userInfo, email: newEmail}),
            setIsActive: (active) => setUserInfo({...userInfo, is_active: active}),
            setIsSuperUser: (isSuper) => setUserInfo({...userInfo, is_super_user: isSuper}),
            setActiveTab: (tab) => updateUserInfo({...userInfo, activeTab: tab}),
            setJwtToken: (token) => updateUserInfo({...userInfo, jwt: token}),
            setTokenType: (token_type) => updateUserInfo({...userInfo, token_type: token_type}),
            userInfo: userInfo,
            setUserInfo: (userInfo) => updateUserInfo(userInfo),
            Logout,
            // jwtExpiiresMilliSecs,
            activeTab: userInfo.activeTab,

    }}>
        {children}
    </UserContext.Provider>
}

export default UserContext